/* @flow */

export default class InvestmentProfile {
  id: number;
  name: string;
  isActive: boolean;
  isMain: boolean;
  companyId: number;
}
